import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';
import feeCalculatorTotal from './feeCalculatorTotal.selector';

const feeCalculatorTotalSel = state => feeCalculatorTotal(state);

const selector = createSelector(
  [feeCalculatorTotalSel],
  (_cashTotal) => {
    const cashTotal = Number(_cashTotal);

    // Debit card fee is just 2.50 added to the cash total
    const debitCardFee = 2.75;
    return precise(cashTotal + debitCardFee);
  },
);

export default selector;
